module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};



//////////////////
// WEBPACK FOOTER
// /opt/wh/whtree/~/core-js/modules/_perform.js
// module id = 804
// module chunks = 0